import React, { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';
import { OrgUomForm } from './OrgUomForm';
import { saveOrgUom, getOrgUomsDefaultItem } from './OrgUomAPIEndpoints';
import { useResponsive } from 'lib/useResponsive';
import { useTranslation } from "react-i18next";
import { useTheme } from '@mui/material/styles';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

/**
 * This component handles the form for creating and editing
 * */
export const OrgUomFormDialog = (props) => {
    const [saving, setSaving] = React.useState(false);
    const [dialogSubmit, setDialogSubmit] = useState(0);
    const { isMobile } = useResponsive();
    const { t } = useTranslation();
    const theme = useTheme();

    let formId = props.id;
    const cepOrgId = props.cepOrgId;
    if (!props.open) {
        formId = 0;
    }

    const handleCancel = () => {
        props.onCancel();
    };

    const handleSave = () => {
        setDialogSubmit(dialogSubmit + 1);
    };

    return (
        <>
            {props.open &&
                <Dialog
                    fullScreen={isMobile}
                    fullWidth={true}
                    maxWidth={"md"}
                    open={props.open}
                    PaperComponent={PaperComponent}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {props.formType} {t('Unit of Measure')}
                    </DialogTitle>
                    <DialogContent>
                        <OrgUomForm
                            cepOrgId={cepOrgId}
                            id={formId}
                            itemToEdit={props.itemToEdit}
                            dialogSubmit={dialogSubmit}
                            onSubmit={async (values) => {
                                setSaving(true);
                                try {
                                    let data = await saveOrgUom(values);

                                    if (data) {
                                        props.onSave(data);
                                    }
                                } finally {
                                    setSaving(false);
                                }
                            }}
                            onError={(error) => {
                                props.onError(error);

                                setSaving(false);
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                    <Button autoFocus onClick={handleCancel} variant={theme.props?.CancelButton?.variant || "outlined"} color={theme.props?.CancelButton?.color}>
                        {t('Cancel')}
                    </Button>
                    <LoadingButton
                        loading={saving}
                        onClick={handleSave}
                        variant="contained"
                    >
                        {t('Save')}
                    </LoadingButton>
                    </DialogActions>
                </Dialog>
            }
        </>
    );
}

OrgUomFormDialog.defaultProps = {
    open: false,
    id: 0,
    itemToEdit: getOrgUomsDefaultItem(),
    onCancel: () => { console.log("onCancel not implemented"); },
    onSave: (data) => { console.log("onSave not implemented"); },
    onError: (error) => { console.error("onError not implemented", error); },
};

OrgUomFormDialog.propTypes = {
    open: PropTypes.bool,
    id: PropTypes.number,
    itemToEdit: PropTypes.object,
};